import { RootState } from '~/store';

export const accountReplenishmentSelector = (state: RootState) => state.accountReplenishment;
